// extracted by mini-css-extract-plugin
export default {"messagePair":"PromptMessagePair-module__messagePair--aUj54","pairHeader":"PromptMessagePair-module__pairHeader--xxS8d"};